import { render, staticRenderFns } from "./coach_edit.vue?vue&type=template&id=4b4d1e68&"
import script from "./coach_edit.vue?vue&type=script&lang=js&"
export * from "./coach_edit.vue?vue&type=script&lang=js&"
import style0 from "./coach_edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coach_edit.vue"
export default component.exports